

import { CategoryReference } from 'apprise-core/category'
import type { Multilang, Revisioned } from 'apprise-core/common'
import { Lifecycle } from 'apprise-core/common'





export type TagLifecycleState = 'active' | 'inactive'

export type BaseTag = {

    id: string

    
    category: CategoryReference

    // short and mnemonic, must be unique in the scope of the tag's type.
    name: Multilang

    // shorter form of the name, preferred in space-constrained contexts.
    shortname?: Multilang

    // free-form and instructional.
    description: Multilang

    // taken from  some codelist of relevance in the application domain.
    code?: string

    // change-tracking info: states, timestamps, and .
    lifecycle: Lifecycle<TagLifecycleState>

    // flags the tag as protected from unintended change to its properties.
    // can change at any time.
    guarded?: boolean

    // flags the tag is required by the system, so it can only be partially changed and it can never be removed.
    // predefined tags cann't change state or dependencies. they may change other fields if/when unguarded.
    // cannot change over time.
    predefined?: boolean,


    // extension point for additional property for the tag. opaque to the backend.
    properties: TagProperties


}

export type Tag = BaseTag & Partial<Revisioned<BaseTag>>

export type TagProperties = Partial<{

    // a boolean combination of tags in same/other categories, intended as dependencies for the tag.
    // if present, must be true or the tag won't be available for use in forms defined over objects of the target type.
    includeCondition: TagExpression

    // the current value of all custom properties (if any) specified in the category of the tag (if any). 
    custom: CustomProperties

    // a single, unconstrained tag property for custom use.
    // this is unconstrained and unstructured and should be superseded by explicit custom properties in most use cases.
    value: any

    //Sort order
    sort: number

}>


export type CustomProperties = Record<string, any>

export type TagReference = string

export const noRef = 'noneOf'

export type TagExpression = {

    terms: ExpressionTerm[]
}

export type TagOperator = 'anyOf' | 'allOf' | 'noneOf'

export type ExpressionTerm = {

    category: string,
    tags: string[],
    op?: TagOperator
}


export type Tagged = {

    tags: TagReference[]
}

export const tagPrefix = 'T'


export const unknownTag = 'unknown'

export const manageTags = { type: 'tag', labels: ["manage"] }

export const tagLifecycleTopic = 'tag'

export type TagPropExcludes = 'value'
